module.exports = __webpack_public_path__ + "media/images/icons/delete_admin-4f7b4728fa3c6cd6d0432db3ce4ed513.svg";